// extracted by mini-css-extract-plugin
export const accountStep = "AccountStep__accountStep__h6K6J";
export const accountTypeWrapper = "AccountStep__accountTypeWrapper__qlG-7";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "AccountStep__buttonWrapper__cjF2E";
export const fieldWrapper = "AccountStep__fieldWrapper__W1kCb";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hidden = "AccountStep__hidden__CmYio";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const tooltip = "AccountStep__tooltip__pLdeh";